import { render, staticRenderFns } from "./ModalFormProfile_BRISI.vue?vue&type=template&id=408052c3&scoped=true&"
import script from "./ModalFormProfile_BRISI.vue?vue&type=script&lang=js&"
export * from "./ModalFormProfile_BRISI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408052c3",
  null
  
)

export default component.exports